<div class="go-top" [ngClass]="{'isVisible': windowIsScrolled }">
  <button (click)="scrollToTop()">Go Top</button>
  <span i18n>Voltar ao topo</span>
</div>
